<span *ngFor="let iType of intervalTypes" class="chart-op" [ngClass]="{'chart-op-selected' : chartIntervalSelected(iType.type)}" (click)="setChartIntervalType(iType.type)">{{iType.label | translate}}</span>
